import { TIME_UNIT_CONVERT_FACTOR } from 'constants/general';
import { Token } from 'interfaces/common.interface';
import jwtDecode from 'jwt-decode';

/** Sync UI/client check: token exists, decodes, and is not expired. */
export const isAccessTokenValid = (token?: string | null): boolean => {
  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode<Token>(token);
    const currentTimeInSecond =
      Date.now() / TIME_UNIT_CONVERT_FACTOR.ONE_SECOND_AS_MILLISECONDS;
    const expirationTimeInSecond = decodedToken.exp;

    if (!expirationTimeInSecond) {
      return false;
    }

    return currentTimeInSecond < expirationTimeInSecond;
  } catch {
    return false;
  }
};
